import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImmomioIconName } from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';
import { IconWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-ticket-cancel-modal',
  templateUrl: './ticket-cancel-modal.component.html',
  styleUrls: ['./ticket-cancel-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImmomioButtonComponent, IconWebComponent, TranslateModule],
})
export class TicketCancelModalWebComponent {
  public activeModal = inject(NgbActiveModal);
  public immomioIconName = ImmomioIconName;
}
